import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Header } from '@/components/layout';
import styles from './EmptyResultsView.module.css';

export const EmptyResultsView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className={styles.emptyContainer}>
        <i
          className="pi pi-check-circle"
          style={{ fontSize: '4rem', color: '#4caf50' }}
        />
        <h2 className={styles.emptyTitle}>No Findings Detected</h2>
        <p className={styles.emptyText}>
          The analysis completed successfully but found no gaps or
          contradictions between the documents. Both documents appear to be
          aligned.
        </p>
        <Button
          label="Back to Analyses"
          icon="pi pi-arrow-left"
          onClick={() => navigate('/analyses')}
          className={styles.backButton}
        />
      </div>
    </>
  );
};
